"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AvailableCardWithIntlProvider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactMintl = require("@godaddy/react-mintl");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _uxUtils = require("@site/ux-utils");
var _sharedComponents = require("@site/shared-components");
var _utils = require("@site/utils");
var _RtbBlock = require("../RtbBlock");
var _favoritesButton = require("@site/favorites-button");
var _AvailableTag = _interopRequireDefault(require("./AvailableTag"));
var _PricingAndPurchase = require("./PricingAndPurchase");
var _CommonCardHeader = require("../common/CommonCardHeader");
var _AvailableCard = _interopRequireDefault(require("../styles/AvailableCard"));
var _BundleDomain = _interopRequireDefault(require("./BundleDomain"));
var _spinner = _interopRequireDefault(require("@ux/spinner"));
var _AvailableCardSkeletonLoader = _interopRequireDefault(require("./AvailableCardSkeletonLoader"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const RtbsPositions = {
  abovePriceInfo: 'abovePriceInfo',
  belowCTA: 'belowCTA'
};
const AvailableCard = props => {
  const {
    overrideProps
  } = (0, _sharedComponents.useComponentDataProvider)();
  const {
    dataCy = 'availableCard',
    displayPercentagePrice = false,
    isBuyingAssistanceTextEnabled = false,
    premiumColorSchema,
    premiumTagBoosted = {},
    customBulletPoints = [],
    itc = '',
    availableDomain,
    availableDomainProduct,
    availableDomainSource,
    img,
    imgSize,
    badge,
    tagTextId,
    buttonProps,
    position,
    infoTextId,
    useBlackAtcButton,
    showTldLogo,
    tldLogoUrl = '',
    airoLogoUrl = '',
    includeAds,
    auctionPhone,
    premiumPhone,
    privateLabelId,
    enableFavorites = true,
    AddToCartButton,
    language,
    eidBase,
    cardHeader,
    cardClassNameOverrides = {},
    termsPricingOptions,
    rtbsPosition = RtbsPositions.belowCTA,
    rtbBlockProps,
    customPricingAndCta,
    bundleCTA,
    regularBundleResult,
    showAestheticBundleDomain = false,
    isResponsive = false,
    isTrendingTldsEnabled,
    trendingTldsTags,
    llcMessageOptions = {},
    isCardLoading,
    apiKey = '',
    favoritesIcons = {
      icon: 'heart',
      filledIcon: 'heart-filled'
    },
    showSkeletonLoader
  } = {
    ...props,
    ...overrideProps
  };
  const EID_CODES = (0, _utils.getEidCodes)(eidBase);
  const celebrateImage = img;
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  const deviceType = (0, _uxUtils.useDeviceType)();
  const {
    isMobile,
    isDesktop
  } = deviceType;
  const {
    isTaken,
    isAvailable,
    showSmartExactMatchDomain
  } = (0, _utils.getExactMatchAvailable)(availableDomain, availableDomainProduct);
  const {
    isAftermarketPremium,
    isAuction,
    isRegPremium,
    renderAsPremium
  } = (0, _utils.getDomainTypes)(availableDomain);
  const showBuyingAssistanceText = renderAsPremium && isBuyingAssistanceTextEnabled;
  const productContent = availableDomainProduct.Content;
  const eidPrefix = `${EID_CODES.ExactMatchCards}.${availableDomainSource}_${(0, _utils.getDomainStatus)({
    isAftermarketPremiumDomain: isAftermarketPremium,
    isAuctionDomain: isAuction,
    isRegPremiumDomain: isRegPremium
  })}_${position}${includeAds && availableDomain?.IsAd ? '_ad' : ''}`;
  const currency = (0, _utils.getCurrency)();
  const defaultAlignment = 'start';
  const alignment = props.alignment || defaultAlignment;
  const showLearnMoreButton = !isMobile && renderAsPremium;
  const {
    backgroundColor
  } = cardClassNameOverrides;
  const isStackBundle = availableDomainSource === _utils.DOMAIN_SOURCES.STACK_BUNDLE;
  const tagSavePercent = regularBundleResult?.SavingsText === '0%' ? '' : regularBundleResult?.SavingsText;
  const {
    isLLCMessageLoading,
    showLLCMessage
  } = llcMessageOptions;
  (0, _react.useEffect)(() => {
    const exactMatchItc = (0, _utils.getItcExactMatch)({
      isAftermarketPremium,
      isRegPremium,
      isAuction,
      isTaken,
      isAvailable,
      domainSource: availableDomainSource,
      itc
    });
    const domainEidPrefix = (0, _utils.getDomainEidPrefix)({
      isAftermarketPremiumDomain: isAftermarketPremium,
      isAuctionDomain: isAuction
    });
    (0, _utils.logSearchTermImpression)({
      domainEntity: availableDomain,
      itc: exactMatchItc,
      eidPrefix,
      currency
    });
    if (isAuction) {
      (0, _utils.logSearchTermImpression)({
        domainEntity: availableDomain,
        itc: exactMatchItc,
        eidPrefix: `${EID_CODES.ExactMatchCards}${domainEidPrefix}_${availableDomain.AuctionTypeId}`,
        currency
      });
    }
    availableDomain?.IsBoostedAftermarket && (0, _utils.logImpression)(EID_CODES.PremiumDomain.BoostImpression);
  }, []);
  const sharedDomainProps = {
    isDesktop,
    extensionColorClassName: (0, _classnames.default)({
      'text-purple': renderAsPremium && !premiumColorSchema,
      'text-primary-o': !renderAsPremium && useBlackAtcButton && !premiumColorSchema,
      'text-primary': !renderAsPremium && !useBlackAtcButton && !premiumColorSchema
    }),
    textClassName: (0, _classnames.default)({
      'font-weight-bold mb-0': !isMobile
    })
  };
  const bundleDomainProps = {
    ...sharedDomainProps,
    ...regularBundleResult,
    showAestheticBundleDomain
  };
  const boostedAftermarketEnabled = premiumTagBoosted && availableDomain?.IsBoostedAftermarket;
  const {
    badgeIcon = null,
    showBoostedTagIcon = false,
    showBoostedNameIcon = false,
    boostedTagTextId,
    boostedTagTextValues,
    boostedTagTooltip,
    boostedTagColor,
    boostedTagSingleConsolidated
  } = boostedAftermarketEnabled ? premiumTagBoosted : {};
  const boostedAftermarketProps = {
    ...(badgeIcon && {
      tagIcon: (0, _uxUtils.getIcon)({
        icon: badgeIcon,
        iconSize: 18,
        className: 'mr-1'
      })
    }),
    ...(showBoostedTagIcon && {
      boostedTagIcon: (0, _uxUtils.getIcon)({
        icon: 'ok',
        iconSize: 18,
        className: boostedTagTextId && 'mr-1'
      })
    }),
    boostedTagTextId,
    boostedTagTextValues,
    boostedTagTooltip,
    boostedTagSingleConsolidated,
    boostedTagColor
  };
  const tagIcon = /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
    dataCy: "boosted-aftermarket-tag",
    color: "bg-highlight",
    className: "ms-2 mr-1",
    icon: (0, _uxUtils.getIcon)({
      icon: 'ok',
      iconSize: 18
    })
  });
  const twoToneDomainProps = {
    ...sharedDomainProps,
    names: availableDomain.NameWithoutExtension ? [availableDomain.NameWithoutExtension] : [],
    extensions: availableDomain.Extension ? [availableDomain.Extension] : [],
    tagIcon: showBoostedNameIcon && (boostedTagTooltip ? /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
      dataCy: "boost-tag-tooltip",
      tooltipContent: Array.isArray(boostedTagTooltip) ? /*#__PURE__*/_react.default.createElement("ul", null, boostedTagTooltip?.map(rtb => /*#__PURE__*/_react.default.createElement("li", {
        key: rtb
      }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: rtb
      })))) : /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
        id: boostedTagTooltip
      }),
      tooltipButtonText: tagIcon,
      id: "domain-name-boost-tag-tooltip",
      openOnHover: !isMobile,
      autoHideTimeout: 1
    }) : tagIcon),
    customColor: premiumColorSchema?.twoToneDomainColor
  };
  const wrapperClasses = (0, _classnames.default)(`d-flex ux-card card-border-radius mb-0 justify-content-${alignment} available-card-div`, {
    'flex-column justify-content-center position-relative': isMobile,
    'w-100 h-100': !isMobile,
    'bg-white': !backgroundColor,
    [backgroundColor]: backgroundColor
  });
  const contentWrapperClasses = (0, _classnames.default)(`d-flex flex-column align-items-${alignment}`, {
    'px-3 mt-4 mb-4 justify-content-center': isMobile,
    'p-3': isMobile && cardHeader,
    'p-5 w-100': !isMobile,
    'domain-card-padding': isResponsive
  });
  const {
    mainPriceStyle = {},
    strikethroughPriceStyle = {},
    disclaimerStyle = {}
  } = isMobile ? _utils.EXACT_MATCH_PRICE_STYLES.mobile : _utils.EXACT_MATCH_PRICE_STYLES.desktop;
  const getPricingStyleOverrides = () => {
    const result = {
      priceContainer: `text-sm-${alignment} mt-1`,
      isInline: !displayPercentagePrice && !celebrateImage,
      mainPriceStyle: mainPriceStyle,
      strikethroughPriceStyle: strikethroughPriceStyle,
      disclaimerStyle: disclaimerStyle
    };
    if (isMobile || celebrateImage || !renderAsPremium) {
      result.priceContainer = 'd-flex flex-column align-items-start';
    }
    if (isMobile) {
      result.isInline = false;
    }
    return result;
  };
  const styleOverrides = getPricingStyleOverrides();

  // In cases where the TLD Logo asset (eg. com.svg) is not available, we display the badge instead.
  const isTagVisible = showTldLogo && !tldLogoUrl || badge;
  const customDomainFeatures = customBulletPoints.map(data => {
    const featText = formatMessage({
      id: data.featText
    });
    const tooltip = formatMessage({
      id: data.tooltip
    });
    return {
      featText,
      tooltip
    };
  });
  const getAvailableCardTags = () => {
    if (includeAds && availableDomain?.IsAd) return /*#__PURE__*/_react.default.createElement(_sharedComponents.Tag, {
      textId: 'promotedTag',
      className: 'text-muted min-h-26-px pb-2 ms-2 mr-1',
      dataCy: 'ad-slot-label'
    });
    return isTrendingTldsEnabled ? /*#__PURE__*/_react.default.createElement(_sharedComponents.TrendingTags, {
      tags: trendingTldsTags
    }) : /*#__PURE__*/_react.default.createElement(_AvailableTag.default, (0, _extends2.default)({
      isTagVisible: isTagVisible,
      tagTextId: tagTextId,
      tagTextValues: {
        percent: tagSavePercent
      },
      isAfterMarketDomain: renderAsPremium,
      isStackBundle: isStackBundle,
      showBuyingAssistanceText: showBuyingAssistanceText,
      isAuctionDomain: isAuction,
      isMobile: isMobile,
      premiumColorSchema: premiumColorSchema,
      domainSource: availableDomainSource,
      auctionPhone: auctionPhone,
      premiumPhone: premiumPhone
    }, boostedAftermarketProps));
  };
  const getRtbBlock = condition => {
    return condition && rtbBlockProps && !showLLCMessage && /*#__PURE__*/_react.default.createElement(_RtbBlock.RtbBlock, rtbBlockProps);
  };
  if (isCardLoading) {
    return showSkeletonLoader ? /*#__PURE__*/_react.default.createElement(_AvailableCardSkeletonLoader.default, null) : /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "availcard-loading-spinner",
      className: "d-flex ux-card card-border-radius mb-0 justify-content-center h-100"
    }, /*#__PURE__*/_react.default.createElement(_spinner.default, null));
  }
  return /*#__PURE__*/_react.default.createElement(_AvailableCard.default, {
    "data-cy": availableDomainSource === _utils.DOMAIN_SOURCES.DOMAIN_PLUS ? `${dataCy}_airo_domain_plus` : dataCy,
    key: `availcard-${position}`,
    className: wrapperClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('favorites-div', {
      'w-100 d-flex flex-column align-items-end': isMobile
    })
  }, enableFavorites && availableDomainSource !== _utils.DOMAIN_SOURCES.STACK_BUNDLE ? /*#__PURE__*/_react.default.createElement(_favoritesButton.FavoritesButton, {
    dataEid: (0, _utils.getExactMatchBuyEID)({
      isAftermarketPremium,
      isRegPremium,
      isAuction
    }),
    domain: availableDomain,
    showLabel: false,
    favoritesIcons: favoritesIcons
  }) : null), celebrateImage && /*#__PURE__*/_react.default.createElement("div", {
    className: 'd-flex flex-column justify-content-center'
  }, /*#__PURE__*/_react.default.createElement("img", {
    "data-cy": `${dataCy}-img`,
    "data-testid": `${dataCy}-img`,
    src: celebrateImage,
    width: imgSize || 150,
    alt: formatMessage({
      id: 'celebrate.available'
    })
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: contentWrapperClasses,
    "data-cy": "availcard",
    "data-testid": "availcard"
  }, cardHeader && /*#__PURE__*/_react.default.createElement(_CommonCardHeader.CommonCardHeader, {
    headerTextId: cardHeader?.headerTextId,
    headerPrice: availableDomain?.PriceDisplay
  }), tldLogoUrl && /*#__PURE__*/_react.default.createElement("img", {
    "data-cy": "tld-logo",
    "data-testid": "tld-logo",
    src: tldLogoUrl,
    width: 50,
    height: 32,
    alt: formatMessage({
      id: 'tldLogoAltText'
    })
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center w-100"
  }, airoLogoUrl && /*#__PURE__*/_react.default.createElement("img", {
    "data-cy": "airo-logo",
    className: "domain-plus-card-airo-logo",
    src: airoLogoUrl,
    alt: formatMessage({
      id: 'godaddyAiroLogo'
    })
  }), getAvailableCardTags()), isStackBundle ? /*#__PURE__*/_react.default.createElement(_BundleDomain.default, bundleDomainProps) : /*#__PURE__*/_react.default.createElement(_sharedComponents.TwoToneDomain, twoToneDomainProps), customBulletPoints && /*#__PURE__*/_react.default.createElement(_sharedComponents.PackageSection, {
    features: customDomainFeatures,
    eid: EID_CODES.ExactMatch
  }), getRtbBlock(rtbsPosition === RtbsPositions.abovePriceInfo), customPricingAndCta ? customPricingAndCta : /*#__PURE__*/_react.default.createElement(_PricingAndPurchase.PricingAndPurchase, {
    isAftermarketPremiumDomain: isAftermarketPremium,
    isAuctionDomain: isAuction,
    availableDomainSource,
    dataCy,
    infoTextId,
    availableDomain,
    availableDomainProduct,
    buttonProps,
    position,
    showLearnMoreButton,
    useBlackAtcButton,
    styleOverrides,
    deviceType,
    displayPercentagePrice,
    showSmartExactMatchDomain,
    privateLabelId,
    AddToCartButton,
    language,
    termsPricingOptions,
    auctionPhone,
    premiumPhone,
    isStackBundle,
    bundleProduct: isStackBundle ? regularBundleResult.DotTypesText : '',
    apiKey
  }), productContent && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)({
      'min-h-1 mt-2': !isMobile
    })
  }, /*#__PURE__*/_react.default.createElement(_sharedComponents.TooltipWrapper, {
    title: productContent.SubHeader,
    tooltipContent: productContent.Messages,
    id: productContent.SubHeader,
    tooltipLabelText: productContent.Header,
    classNames: {
      tooltipWrapper: 'ms-2'
    }
  })), bundleCTA, isLLCMessageLoading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("hr", {
    className: "w-100"
  }), /*#__PURE__*/_react.default.createElement(_sharedComponents.SkeletonLoader, {
    width: "75%"
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, getRtbBlock(rtbsPosition === RtbsPositions.belowCTA), showLLCMessage && /*#__PURE__*/_react.default.createElement(_sharedComponents.LLCMessage, {
    llcMessageOptions: llcMessageOptions,
    domainName: availableDomain.Fqdn
  }))));
};
AvailableCard.propTypes = {
  availableDomain: _propTypes.default.object.isRequired,
  availableDomainProduct: _propTypes.default.object.isRequired,
  availableDomainSource: _propTypes.default.string.isRequired,
  privateLabelId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
  eidBase: _propTypes.default.string,
  infoTextId: _propTypes.default.string,
  useBlackAtcButton: _propTypes.default.bool,
  dataCy: _propTypes.default.string,
  img: _propTypes.default.string,
  imgSize: _propTypes.default.number,
  badge: _propTypes.default.bool,
  tagTextId: _propTypes.default.string,
  language: _propTypes.default.object,
  buttonProps: _propTypes.default.shape({
    addToCartText: _propTypes.default.string,
    verifyingText: _propTypes.default.string,
    removeFromCartText: _propTypes.default.string,
    removingFromCartText: _propTypes.default.string
  }),
  alignment: _propTypes.default.string,
  position: _propTypes.default.number,
  showTldLogo: _propTypes.default.bool,
  customBulletPoints: _propTypes.default.arrayOf(_propTypes.default.shape({
    featText: _propTypes.default.string,
    tooltip: _propTypes.default.string
  })),
  premiumColorSchema: _propTypes.default.object,
  auctionPhone: _propTypes.default.string,
  premiumPhone: _propTypes.default.string,
  enableFavorites: _propTypes.default.bool,
  AddToCartButton: _propTypes.default.func,
  tldLogoUrl: _propTypes.default.string,
  cardHeader: _propTypes.default.shape({
    headerTextId: _propTypes.default.string
  }),
  cardClassNameOverrides: _propTypes.default.shape({
    backgroundColor: _propTypes.default.string
  }),
  termsPricingOptions: _propTypes.default.shape({
    showTermsPricing: _propTypes.default.bool,
    displayMonthlyPricing: _propTypes.default.bool,
    showMonthlyPriceDisclaimer: _propTypes.default.bool,
    hideListPrice: _propTypes.default.bool,
    showFreeIndicator: _propTypes.default.bool
  }),
  rtbsPosition: _propTypes.default.oneOf(Object.values(RtbsPositions)),
  rtbBlockProps: _propTypes.default.shape(_RtbBlock.RtbBlock.propTypes),
  customPricingAndCta: _propTypes.default.element,
  bundleCTA: _propTypes.default.element,
  regularBundleResult: _propTypes.default.object,
  showAestheticBundleDomain: _propTypes.default.bool,
  isResponsive: _propTypes.default.bool,
  isTrendingTldsEnabled: _propTypes.default.bool,
  trendingTldsTags: _propTypes.default.arrayOf(_propTypes.default.object),
  llcMessageOptions: _propTypes.default.shape(_sharedComponents.LLCMessage.propTypes),
  isCardLoading: _propTypes.default.bool,
  showSkeletonLoader: _propTypes.default.bool
};
const AvailableCardWithIntlProvider = ({
  language,
  ...props
}) => {
  const market = (0, _utils.getMarket)();
  const {
    languageStrings
  } = (0, _sharedComponents.useComponentDataProvider)(language);
  return /*#__PURE__*/_react.default.createElement(_reactMintl.IntlProvider, {
    locale: market,
    messages: languageStrings
  }, /*#__PURE__*/_react.default.createElement(AvailableCard, (0, _extends2.default)({}, props, {
    language: languageStrings
  })));
};
exports.AvailableCardWithIntlProvider = AvailableCardWithIntlProvider;
AvailableCardWithIntlProvider.propTypes = {
  ...AvailableCard.propTypes,
  language: _propTypes.default.object
};
const AvailableCardWithComponentDataProvider = props => {
  const {
    appName,
    apiKey,
    forceEnableBFF,
    enableFavorites = true,
    privateLabelId = 1,
    urlOverride = 'godaddy.com',
    uipProps
  } = props;
  return /*#__PURE__*/_react.default.createElement(_sharedComponents.ComponentDataProvider, (0, _extends2.default)({
    componentName: "cards",
    appName: appName,
    apiKey: apiKey,
    forceEnableBFF: forceEnableBFF
  }, enableFavorites && {
    uipProps: {
      plid: privateLabelId,
      urlOverride,
      ...uipProps
    }
  }), /*#__PURE__*/_react.default.createElement(AvailableCardWithIntlProvider, props));
};
AvailableCardWithComponentDataProvider.propTypes = {
  ...AvailableCardWithIntlProvider.propTypes,
  uipProps: _propTypes.default.object,
  apiKey: _propTypes.default.string.isRequired,
  appName: _propTypes.default.string.isRequired,
  urlOverride: _propTypes.default.string.isRequired
};
var _default = exports.default = AvailableCardWithComponentDataProvider;